import React from 'react';
import Typography, { TypographyProps, } from '@material-ui/core/Typography';

import { useWidth, } from 'common/hooks';

type Props = TypographyProps & {
    // TODO PB Set proper typing.
    component?: any,
};

enum HeaderVariant {
    xs = 'h6',
    sm = 'h6',
    md = 'h4',
    lg = 'h4',
    xl = 'h4',
}

const TypographyWrapper: React.FC<Props> = ({
    children,
    component,
    variant,
}) => {
    const widthBreakpoint = useWidth();
    const currentBreakpointWidth = variant || HeaderVariant[widthBreakpoint];

    return (
        <Typography component={component}
                    variant={currentBreakpointWidth}>
            {children}
        </Typography>
    );
};

TypographyWrapper.defaultProps = {
    component: 'h1',
};

export default TypographyWrapper;
